import { render, staticRenderFns } from "./ProfileNoteItem.vue?vue&type=template&id=11b02930&scoped=true&"
import script from "./ProfileNoteItem.vue?vue&type=script&lang=js&"
export * from "./ProfileNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNoteItem.vue?vue&type=style&index=0&id=11b02930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b02930",
  null
  
)

export default component.exports